import { useQuery } from '@tanstack/react-query';
import { POLL_INTERVAL_MS, type QrBatchStats } from '../lib/qrBatch';
import { qrBatchStatsKey } from '../lib/queryKeys';

export interface UseQrBatchStats {
  stats: QrBatchStats | undefined;
  isPending: boolean;
  isError: boolean;
  retry: () => void;
}

// Polls at the list's pace while the caller says a batch is generating, and not otherwise.
export function useQrBatchStats(
  fetchQrBatchStats: () => Promise<QrBatchStats>,
  polling: boolean,
): UseQrBatchStats {
  const query = useQuery({
    queryKey: qrBatchStatsKey(),
    queryFn: fetchQrBatchStats,
    refetchInterval: polling ? POLL_INTERVAL_MS : false,
  });

  return {
    stats: query.data,
    isPending: query.isPending,
    isError: query.isError,
    retry: () => {
      void query.refetch();
    },
  };
}
